import { EnquiryPage } from '../enquiryPage';

window.addEventListener('DOMContentLoaded', async () => {
  const enquiryPage = new EnquiryPage();
  enquiryPage.setupPage();
});
